import {createSelector} from "reselect";

const orgs = (state) => state.org;

const orgsData = createSelector(orgs, (data) => data?.organizationsData || {});

export const getOrganizationList = createSelector(
  orgsData,
  (data) => data?.results || []
);

export const getTotalCount = createSelector(orgsData, (data) => data?.count);

export const getOrgsPaginationUrls = createSelector(orgsData, (data) => ({
  prevUrl: data?.previous,
  nextUrl: data?.next,
}));

export const getOrganization = createSelector(
  orgs,
  (orgs) => orgs.selectedOrganization || {}
);

export const getOrganizationApps = createSelector(orgs, (orgs) => orgs.apps);
